/** Canonical public URL for a numbered onboarding illustration. */
export function onboardingImageUrl(step: number, variant?: "a" | "b"): string {
  if (variant) {
    return `/onboarding/${step}${variant}.webp`;
  }
  return `/onboarding/${step}.webp`;
}

/** Ordered candidates for screen 9 branching (social vs interruptions). */
export function onboardingImageCandidates(
  step: number,
  branch?: "social" | "other",
): string[] {
  if (step === 9) {
    if (branch === "social") {
      return [onboardingImageUrl(9), onboardingImageUrl(9, "a")];
    }
    return [onboardingImageUrl(9, "b"), onboardingImageUrl(9)];
  }
  return [onboardingImageUrl(step)];
}
